import { Floor } from './floor';

export function Building(name = 'בניין חדש', floors) {
    return {
        id: `building-${Date.now()}`,
        name,
        floors: floors ?? [Floor()]
    }
}

export function addFloor(building, floor) {
    const newFloor = floor ?? Floor();
    return { ...building, floors: [...building.floors, newFloor] };
}

export function removeFloor(building, floorId) {
    return { ...building, floors: building.floors.filter(floor => floor.id !== floorId) };
}

export function updateFloor(building, updatedFloor) {
    return { ...building, floors: building.floors.map(floor => floor.id === updatedFloor.id ? updatedFloor : floor) };
}

export function updateRoom(building, roomId, updatedRoom) {
    const updatedFloors = building.floors.map(floor => {
        if (!floor.rooms?.some(room => room.id === roomId)) {
          return floor;
        }
        return {
          ...floor,
          rooms: floor.rooms.map(room =>
            room.id === roomId ? updatedRoom : room
          )
        };
      });
    const buildingWithUpdatedFloors = { ...building, floors: updatedFloors };
    console.log('UPDATE_ROOM', buildingWithUpdatedFloors);
    return buildingWithUpdatedFloors;
}